import type { UserServerType, UserType } from '@/lib/types/user.types'

export const normalizeUser = (user: UserServerType): UserType => {
  return {
    id: user.id,
    isAdmin: !!user.admin,
    username: user.username,
    email: user.email,
    firstName: user.first_name,
    lastName: user.surname,
    locale: user.locale,
    storeGroupId: user.store_group_id,
    currency: {
      code: user.currencyObj.code,
      isBefore: user.currencyObj.is_before,
      name: user.currencyObj.name,
      ratioToEur: user.currencyObj.ratio_to_eur,
      subunit: user.currencyObj.subunit,
      symbol: user.currencyObj.symbol,
    },
    subscriber: {
      id: user.subscriber.id,
      hash: user.subscriber.hash,
    },
  }
}
